import AccountsTable from "./_components/AccountsTable";

export default function AccountsDashboard(props) {
  return (
    <div style={{maxWidth: 1100}}>
      <AccountsTable {...props} />
    </div>
  );
}
